/** Le profil, les reglages et le compte. */
export const profil = {
  erreurs: {
    compteIntrouvable: 'Compte introuvable',
    membreIntrouvable: 'Membre introuvable',
    pseudoPris: "Ce nom d'utilisateur est déjà pris",
    spotIntrouvable: 'Spot introuvable',
    bientot: (spot: string) => `${spot} ouvre bientôt, reste connecté !`,
    prive: (spot: string) => `${spot} est réservé à ses membres.`,
  },
  aideErreurs: {
    vide: 'Explique-nous ce qui se passe',
  },
  commun: {
    changerPhoto: 'Changer ma photo de profil',
    mesDestinations: 'Mes destinations',
    mesPosts: 'Mes posts',
    mesEvenements: 'Mes événements',
    mesAmis: 'Mes amis',
    mesSignets: 'Mes signets',
    voirTout: 'Voir tout',
    notePar: (note: string, n: number) => `Noté ${note} sur 5 par ${n} participants`,
    personnaliser: 'Personnaliser mon profil',
    bio: 'Bio',
    debloquer: 'Débloquer',
    membresBloques: 'Membres bloqués',
    visibilite: 'Visibilité du profil',
    parametres: 'Paramètres',
    aide: 'Aide et signalements',
    ajouterAmis: 'Ajouter des amis',
    ecrireA: (nom: string) => `Écrire à ${nom}`,
  },
  compte: {
    photoMiseAJour: 'Photo mise à jour.',
    photoRetiree: 'Photo retirée.',
    photoImpossible: 'Photo impossible à enregistrer',
    enregistre: 'Profil enregistré.',
    impossible: 'Enregistrement impossible',
    enregistrer: 'Enregistrer',
    retirerPhoto: 'Retirer ma photo',
    pseudo: "Nom d'utilisateur",
    bioExemple: 'Deux lignes sur toi, ce que tu cherches ici...',
    langues: 'Langues parlées',
    languesAide: 'Les sorties dans tes langues passent en tête de liste.',
  },
  masques: {
    titre: 'Masqués et bloqués',
    comptesMasques: 'Comptes masqués',
    comptesBloques: 'Comptes bloqués',
    postsMasques: 'Posts masqués',
    afficher: 'Ne plus masquer',
    impossible: 'Impossible pour le moment.',
    comptes: {
      personne: 'Aucun compte masqué',
      personneAide: 'Tu peux masquer un compte depuis son profil, avec les trois points en haut à droite.',
      explication: 'Tu ne vois plus leurs publications ni leurs sorties. Ils ne le savent pas, et rien d’autre ne change entre vous.',
      masque: 'Masqué',
    },
    posts: {
      aucun: 'Aucun post masqué',
      aucunAide: 'Les posts que tu masques depuis le fil se retrouvent ici.',
    },
  },
  bloques: {
    impossible: 'Déblocage impossible pour le moment.',
    personne: "Personne n'est bloqué",
    personneAide: 'Tu peux bloquer un membre depuis son profil, via les trois points en haut à droite.',
    explication: "Leurs posts et leurs événements n'apparaissent plus chez toi, et vos conversations sont masquées.",
    bloque: 'Bloqué',
  },
  destinations: {
    villes: 'Villes',
    actuel: 'Serveur actuel',
    changer: 'Changer de serveur',
  },
  amis: {
    aucun: "Tu n'as pas encore d'ami",
    aucunAide: "Les suggestions du serveur et les demandes reçues t'attendent.",
    trouver: 'Trouver des membres',
  },
  aide: {
    impossible: 'Envoi impossible pour le moment.',
    envoyer: 'Envoyer',
    intro: 'Dis-nous ce qui se passe. Notre équipe lit tout, et te répond par e-mail.',
    sujet: "De quoi s'agit-il ?",
    raconte: 'Raconte-nous',
    raconteExemple: "Ce qui s'est passé, où, et avec qui si c'est le cas.",
    sujets: {
    member: 'Un membre',
    event: 'Un événement',
    content: 'Un post ou un message',
    bug: 'Un problème technique',
    other: 'Autre chose',
  },
  },
  membre: {
    ami: {
      none: 'Demander en ami',
      requested: 'Demande envoyée',
      incoming: 'Accepter la demande',
      friends: 'Retirer des amis',
    },
    ceMembre: 'ce membre',
    profil: 'Profil',
    refuserQ: 'Refuser sa demande d’ami ?',
    refuser: "Refuser sa demande d'ami",
    debloquerMembre: 'Débloquer ce membre',
    bloquerMembre: 'Bloquer ce membre',
    masquerCompte: 'Masquer ce compte',
    nePlusMasquer: 'Ne plus masquer ce compte',
    estMasque: (nom: string) => `Tu as masqué ${nom}. Tu ne verras plus ses publications ni ses événements.`,
    plusMasque: (nom: string) => `Tu ne masques plus ${nom}.`,
    ecrire: 'Lui écrire',
    tuAsBloque: 'Tu as bloqué ce membre',
    tuAsBloqueAide: 'Ses posts n’apparaissent plus dans ton feed, et cette personne ne t’est plus suggérée.',
    officiel: "C'est le compte de l'équipe Sirocco. Écris-lui pour toute question.",
    reserve: 'Profil réservé à ses amis',
    reserveAide: 'Demande-le en ami pour voir ses posts.',
    sesDestinations: 'Ses destinations',
    sesEvenementsMasques: 'Ses événements sont masqués par ses réglages.',
    demandeRefusee: (nom: string) => `Demande de ${nom} refusée.`,
    debloque: (nom: string) => `Tu as débloqué ${nom}.`,
    bloquerQ: (nom: string) => `Bloquer ${nom} ?`,
    bloque: (nom: string) =>
      `Tu as bloqué ${nom}. Cette personne ne peut plus t’envoyer de message ni te demander en ami.`,
    retirerAmiQ: (nom: string) => `Retirer ${nom} de tes amis ?`,
    plusAmi: (nom: string) => `${nom} ne fait plus partie de tes amis.`,
    appeler: (nom: string) => `Appeler ${nom}`,
    avis: (n: string) => `· ${n} avis`,
  },
  notifications: {
    choix: {
      messages: 'Messages',
      appels: 'Appels',
      amis: "Demandes d'ami",
      postsAmis: 'Posts de mes amis',
      evenements: 'Événements',
      acceptee: 'Participation acceptée',
      inscriptions: 'Inscriptions à mes événements',
      desinscriptions: 'Désinscriptions à mes événements',
      reactions: 'Réactions à mes publications',
      mentions: 'Mentions',
    },
    titre: 'Notifications',
  },
  motDePasse: {
    troisConditions: 'Ce mot de passe ne remplit pas les trois conditions',
    pasIdentiques: 'Les deux mots de passe ne correspondent pas',
    impossible: 'Changement impossible',
    titre: 'E-mail et mot de passe',
    changer: 'Changer mon mot de passe',
    actuel: 'Mot de passe actuel',
    nouveau: 'Nouveau mot de passe',
    confirmer: 'Confirmer le nouveau mot de passe',
    envoye: 'Courriel envoyé',
    lienRecu: (email: string) => `Ouvre le lien reçu à ${email} pour choisir un nouveau mot de passe.`,
  },
  ecran: {
    modifier: 'Modifier mon profil',
    mesEvenementsSorties: 'Mes événements et sorties',
  },
  visibilite: {
    intro: 'Choisis ce que les autres membres du serveur voient quand ils ouvrent ton profil.',
    quiPeutVoir: 'Qui peut voir mon profil',
    toutLeServeur: 'Tout le serveur',
    amisSeulement: 'Mes amis seulement',
    ceQuiApparait: 'Ce qui apparaît sur mon profil',
    evenementsAide: 'Les autres voient à quoi je participe',
    mesDestinationsAide: 'Les villes où je suis passé',
    postsAide: 'Visibles depuis mon profil',
    enLigne: 'Statut en ligne',
    enLigneAide: 'Point vert sur mon avatar',
    destinationsAmis: 'Mes destinations aux amis seulement',
    destinationsAide: 'Les villes où je suis passé, réservées à mes amis',
    messages: 'Messages',
  },
  tableau: {
    mois: 'Les 30 derniers jours',
    posts: 'posts',
    tenues: 'événements tenus',
    presences: 'présences',
    inscriptions: 'Inscriptions par semaine',
    cetteSemaine: 'cette semaine',
    ilYaSemaines: (n: number) => `il y a ${n} sem.`,
    nInscriptions: (n: number) => (n === 1 ? '1 inscription' : `${n} inscriptions`),
    fidelite: 'Fidélité',
    revenus: 'reviennent après leur première semaine',
    encoreActifs: 'encore actifs après un mois',
    surN: (n: number, sur: number) => `${n} sur ${sur}`,
    pasAssez: 'pas encore assez de recul',
    parServeur: 'Par serveur',
    serveurLigne: (membres: number, actifs: number) =>
      `${membres} membre${membres > 1 ? 's' : ''} · ${actifs} actif${actifs > 1 ? 's' : ''} cette semaine`,
    serveurDetail: (posts: number, tenues: number, presences: number, aVenir: number) =>
      `${posts} post${posts > 1 ? 's' : ''} (7 j) · ${tenues} événement${tenues > 1 ? 's' : ''} et ${presences} présence${presences > 1 ? 's' : ''} (30 j) · ${aVenir} à venir`,
    sansServeur: 'sans serveur',
    titre: 'Tableau de bord',
    actifsAujourdhui: 'actifs aujourd’hui',
    semaine: 'cette semaine',
    comptes: 'comptes',
    nouveaux: 'nouveaux (7 j)',
    unSignalement: '1 signalement attend une décision',
    connexions: 'Dernières connexions',
    versions: 'Versions installées',
    unCompte: '1 compte',
    sorties: 'Sorties à venir',
    rien: 'Rien de prévu pour l’instant.',
    spontanee: 'spontanée',
    jamais: 'jamais',
    depuis: {
    minutes: (n: number) => `il y a ${n} min`,
    heures: (n: number) => `il y a ${n} h`,
    jours: (n: number) => `il y a ${n} j`,
  },
    build: (n: string) => ` · build ${n}`,
    signalements: (n: number) => `${n} signalements attendent une décision`,
    nComptes: (n: number) => `${n} comptes`,
  },
  reglages: {
    apparences: {
      system: 'Automatique',
      day: 'Clair',
      night: 'Sombre',
    },
    apparenceAide: {
      system: 'Suit le réglage de ton iPhone.',
      day: 'Toujours clair, quel que soit le téléphone.',
      night: 'Toujours sombre, quelle que soit l’heure.',
    },
    deconnexionImpossible: 'Déconnexion impossible. Réessaie.',
    suppressionImpossible: 'Suppression impossible',
    compte: 'Compte',
    emailEtMotDePasse: 'Adresse e-mail et mot de passe',
    serveur: 'Serveur / destination',
    confidentialite: 'Confidentialité',
    coupees: 'Désactivées dans les réglages du téléphone',
    moderation: 'Modération',
    tableau: 'Tableau de bord',
    administration: 'Administration',
    application: 'Application',
    apparence: 'Apparence',
    langue: 'Langue',
    deconnecterQ: 'Se déconnecter ?',
    deconnecter: 'Se déconnecter',
    supprimerQ: 'Supprimer définitivement ton compte ? Tes publications et tes messages seront effacés.',
    supprimer: 'Supprimer mon compte',
  },
};
